import React from 'react';

import DetailsForm from 'components/forms/DetailsForm';

const DetailsPage = () => {
  return <DetailsForm />;
};

export default DetailsPage;
